module.exports = __webpack_public_path__ + "img/ALSH_SEJOUR_HIVER.b7af899d.svg";